// assets/nine11-comparison-slider.js

/**
 * Inicializa un slider de comparación "Antes y Después"
 */
function initializeComparisonSlider(containerId) {
  const container = document.getElementById(containerId);
  if (!container) return;

  const handle = container.querySelector('.slider-handle');
  const imageBefore = container.querySelector('.image-before');
  const beforeLabel = container.querySelector('.label-before');
  const afterLabel = container.querySelector('.label-after');

  if (!handle || !imageBefore) return;

  let isDragging = false;
  const rootElement = document.documentElement;

  /* ---------------------------
     FUNCIÓN OCULTAR / MOSTRAR LABELS
  ---------------------------- */
  let hideLabelsTimeout;

  const hideLabels = () => {
    if (beforeLabel) beforeLabel.style.opacity = "0";
    if (afterLabel) afterLabel.style.opacity = "0";

    // Volver a mostrar luego de 700 ms sin arrastrar
    clearTimeout(hideLabelsTimeout);
    hideLabelsTimeout = setTimeout(() => {
      if (beforeLabel) beforeLabel.style.opacity = "1";
      if (afterLabel) afterLabel.style.opacity = "1";
    }, 700);
  };

  /* ---------------------------
     FUNCIÓN PARA ACTUALIZAR SLIDER
  ---------------------------- */
  const updateSlider = (clientX) => {
    const containerRect = container.getBoundingClientRect();
    let newX = clientX - containerRect.left;

    // Límites
    if (newX < 0) newX = 0;
    if (newX > containerRect.width) newX = containerRect.width;

    handle.style.left = `${newX}px`;
    imageBefore.style.width = `${newX}px`;

    // Ocultar etiquetas mientras se mueve
    hideLabels();
  };

  /* ---------------------------
     MOUSE EVENTS
  ---------------------------- */
  const onMove = (e) => {
    if (!isDragging) return;
    updateSlider(e.clientX);
  };

  const onUp = () => {
    isDragging = false;
    handle.style.cursor = 'ew-resize';
    rootElement.removeEventListener('mousemove', onMove);
    rootElement.removeEventListener('mouseup', onUp);
  };

  const onMouseDown = (e) => {
    isDragging = true;
    handle.style.cursor = 'grabbing';
    e.preventDefault();
    rootElement.addEventListener('mousemove', onMove);
    rootElement.addEventListener('mouseup', onUp);
  };

  /* ---------------------------
     TOUCH EVENTS
  ---------------------------- */
  const onTouchMove = (e) => {
    if (!isDragging || e.touches.length === 0) return;
    updateSlider(e.touches[0].clientX);
  };

  const onTouchEnd = () => {
    isDragging = false;
    rootElement.removeEventListener('touchmove', onTouchMove);
    rootElement.removeEventListener('touchend', onTouchEnd);
  };

  const onTouchStart = (e) => {
    isDragging = true;
    e.preventDefault();
    rootElement.addEventListener('touchmove', onTouchMove);
    rootElement.addEventListener('touchend', onTouchEnd);
  };

  /* ---------------------------
     ASIGNAR LISTENERS
  ---------------------------- */
  handle.addEventListener('mousedown', onMouseDown);
  handle.addEventListener('touchstart', onTouchStart);

  /* ---------------------------
     POSICIÓN INICIAL (50%)
  ---------------------------- */
  const setInitialPosition = () => {
    const initialOffset = container.offsetWidth / 2;
    handle.style.left = `${initialOffset}px`;
    imageBefore.style.width = `${initialOffset}px`;
  };

  setInitialPosition();

  // Reset cuando cambia el tamaño de la ventana
  window.addEventListener('resize', setInitialPosition);
}

/* ---------------------------
   HACER FUNCIÓN GLOBAL
---------------------------- */
window.initializeComparisonSlider = initializeComparisonSlider;

/* ---------------------------
   INICIALIZACIÓN AUTOMÁTICA
---------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  const comparisonSliders = document.querySelectorAll('.comparison-slider-wrapper');
  comparisonSliders.forEach(slider => {
    initializeComparisonSlider(slider.id);
  });
});